(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["blog-latest-articles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('blog-list-filter')) {
    class BlogListFilter extends HTMLElement {
      connectedCallback() {
        if (this.dataset.filter !== 'true') return;
        const scope = this.closest('.shopify-section') || document;
        this.links = [...scope.querySelectorAll('a[href]')].filter((a) => !this.contains(a) && this.blogOf(a) !== null);
        this.links.forEach((a) => {
          a.setAttribute('role', 'button');
          a.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(this.blogOf(a));
          });
        });
        this.select('');
      }

      // '' = « Tous » (lien vers la page du blog), sinon le handle de la rubrique
      blogOf(a) {
        const path = new URL(a.href, location.href).pathname;
        if (/\/pages\/blogs\/?$/.test(path)) return '';
        const m = path.match(/\/blogs\/([^/]+)\/?$/);
        return m ? m[1] : null;
      }

      select(blog) {
        this.links.forEach((a) => {
          const on = this.blogOf(a) === blog;
          a.setAttribute('aria-pressed', on);
          a.classList.toggle('btn-2', on);
          a.classList.toggle('btn-1', !on);
          a.classList.toggle('btn-outline', !on);
        });
        let shown = 0;
        this.querySelectorAll('.bla__item').forEach((item) => {
          item.hidden = blog !== '' && item.dataset.blog !== blog;
          if (!item.hidden) shown++;
        });
        this.querySelector('.bla__empty').hidden = shown > 0;
      }
    }
    customElements.define('blog-list-filter', BlogListFilter);
  }
  } catch(e) { console.error(e); }
})();

})();
